module.exports = __webpack_public_path__ + "static/img/e.31c492a8.png";